export const lessonTypes = {
  cms_lessons: "Learn",
  waggle5: "Skill Quiz",
  game: "Game",
  practicepack: "Practice",
};
